import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import './SectionHeader.css';

const SECTION_ICONS = {
  'Hot Coffee': '☕',
  'Cold Drinks': '🧊',
  'Pastries': '🥐',
  'Light Bites': '🥗',
  'Desserts': '🍰',
  'Beverages': '🥤',
  'Starters': '🥗',
  'Main Courses': '🍽️',
  'Appetizers': '🥗',
  'Soups': '🍲',
  'Salads': '🥗',
  'Sides': '🥔',
  'Other': '🍽️',
};

function sectionToKey(name) {
  return (name || '')
    .trim()
    .split(/\s+/)
    .map((w, i) => (i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
    .join('');
}

const SectionHeader = ({ sectionName, displayName, itemCount, isSticky }) => {
  const { t } = useTranslation();
  // Icon, subtitle key and anchor id derive from the base (English) section name
  // so they keep resolving; only the visible title uses the translated name.
  const subtitleKey = `menu.sections.${sectionToKey(sectionName)}`;
  const subtitle = t(subtitleKey);
  const showSubtitle = subtitle && subtitle !== subtitleKey;
  const icon = SECTION_ICONS[sectionName] || '🍽️';
  const title = displayName || sectionName;

  return (
    <Box
      component="header"
      className={`menu-section-header ${isSticky ? 'menu-section-header--sticky' : ''}`}
      sx={{
        marginBottom: 3,
        paddingBottom: 2,
        borderBottom: '2px solid',
        borderColor: 'divider',
        scrollMarginTop: 72,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <span className="menu-section-header-icon" aria-hidden="true">
          {icon}
        </span>
        <Typography
          variant="h2"
          component="h2"
          id={`section-${(sectionName || '').replace(/\s+/g, '-')}`}
          className="menu-section-header-title"
          sx={{
            fontSize: { xs: '1.35rem', sm: '1.5rem' },
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.3,
          }}
        >
          {title}
          {itemCount != null && itemCount > 0 && (
            <Typography
              component="span"
              variant="body1"
              color="text.secondary"
              sx={{ fontWeight: 500, ml: 0.5, fontSize: 'inherit' }}
            >
              ({itemCount})
            </Typography>
          )}
        </Typography>
      </Box>
      {showSubtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          className="menu-section-header-subtitle"
          sx={{ mt: 0.5, fontSize: '0.875rem' }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeader;
